import generateQRSaga from './generateQRSaga'

const qrSagas = [generateQRSaga()]

export default qrSagas
